// extracted by mini-css-extract-plugin
export default {"DismissibleFlashContainer":"DismissibleFlash-module__DismissibleFlashContainer__VStmCle","dismissButton":"DismissibleFlash-module__dismissButton__GEPy8Hj"};